import styles from "./UpdatePassword.module.css";
import Button from "../utilities/button/Button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

function UpdatePassword() {
  const navigate = useNavigate();

  const [emailUserName, setemailUserName] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errStatus, setErrStatus] = useState("");
  const [overlapStatus, setOverlapStatus] = useState(false);
  const [subtBtnStatus, setSubtBtnStatus] = useState(false);
  const [formInput, setFormInput] = useState(false);
  const [seePassword, setSeePassword] = useState(false);

  function emailHandler(e) {
    setemailUserName(e.target.value);
  }

  function oldPasswordHandler(e) {
    setOldPassword(e.target.value);
  }

  function newPasswordHandler(e) {
    setNewPassword(e.target.value);
  }

  async function submitHandler(e) {
    e.preventDefault();
    setSubtBtnStatus(true);
    setFormInput(true);
    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/user/update`,
        {
          method: "POST",
          body: JSON.stringify({ emailUserName, oldPassword, newPassword }),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (result.status >= 400) throw new Error("Bad Credential try again");
      if (result.status === 200) {
        setOverlapStatus(true);
        setSubtBtnStatus(false);
        setFormInput(false);
      }
    } catch (err) {
      setErrStatus(err);
    }
  }

  function LoginAgain() {
    localStorage.clear();
    navigate("/login");
    setOverlapStatus(false);
  }

  function passwordSeeHandler() {
    setSeePassword((val) => !val);
  }

  return (
    <>
      <div
        className={
          overlapStatus ? `${styles.overlap}` : `${styles.overlapClose}`
        }
      >
        <div className={styles.overlapBox}>
          <div className={styles.overlapOk}>
            <p className={styles.overlapPara}>
              You Password Changed Successfully Now Loging Again
            </p>
            <Button handleClick={LoginAgain}>Ok</Button>
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.box}>
          <h1 className={styles.heading}>Update Password</h1>
          <form onSubmit={submitHandler} className={styles.form}>
            <div className={styles.passwordBox}>
              <input
                className={styles.input}
                type="text"
                placeholder="Enter you email or User Id"
                value={emailUserName}
                onChange={emailHandler}
                disabled={formInput}
              ></input>
            </div>
            <div className={styles.passwordBox}>
              <input
                className={styles.input}
                type={seePassword ? "text" : "password"}
                placeholder="Enter Your Old Password"
                value={oldPassword}
                onChange={oldPasswordHandler}
                disabled={formInput}
              ></input>
              <div onClick={passwordSeeHandler}>
                {seePassword ? <FaEye></FaEye> : <FaEyeSlash></FaEyeSlash>}
              </div>
            </div>
            <div className={styles.passwordBox}>
              <input
                className={styles.input}
                type={seePassword ? "text" : "password"}
                placeholder="Enter your New Password"
                value={newPassword}
                onChange={newPasswordHandler}
                disabled={formInput}
              ></input>
              <div onClick={passwordSeeHandler}>
                {seePassword ? <FaEye></FaEye> : <FaEyeSlash></FaEyeSlash>}
              </div>
            </div>
            <Button
              disabled={oldPassword.length <= 0 || newPassword.length <= 0}
            >
              {subtBtnStatus ? "Wait..." : "Update"}
            </Button>
          </form>
          <p style={{ color: "red" }}>{errStatus}</p>
        </div>
      </div>
    </>
  );
}

export default UpdatePassword;
